import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { BLACK_50 } from '@/ui-kit/theme';

export const StyledDescription = styled.div(() => {
  return {
    fontSize: '16px',
    lineHeight: '150%',
    color: BLACK_50,
    textAlign: 'center',
  };
});

interface IDescriptionProps extends PropsWithChildren {
  className?: string;
}

export const Description = ({
  className,
  children,
}: IDescriptionProps) => {
  return (
    <StyledDescription className={className}>{children}</StyledDescription>
  );
};
